const defaultCrudConfig = {
    endpoint: 'codesystems',
    primaryKey: 'codeSystemId',
    globalSearchFieldName: 'text',
    globalSearchQueryClass: 'ByGeneralProperties',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        // fetchBy: {
        //     method: 'get',
        //     returnType: 'Array',
        //     service: 'cds',
        //     args: ['type', 'queryClass', 'arg'],
        //     query: {
        //         filter: '#@type@#=#@arg@#',
        //         property: 'queryClass=#@queryClass@#'
        //     },
        // },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemId'],
            query: {
                filter: 'codeSystemId=#@codeSystemId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemId', 'vsDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds',
            args: ['codeSystemId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemDoc']
        }
    }
};

export default defaultCrudConfig;
